<template>
    <div class="airPurifiers_main" :class="{'cn':version == '1'}">
        <div class="airPurifiers_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="airPurifiers_right">
            <div class="airPurifiers_right_top">
                <div class="right_top_l">
                    <el-select v-model="buildId">
                        <el-option
                            v-for="item in buildNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input :placeholder="$t('App.lights.text24')" v-model="keywords" @keyup.native="getUVLightListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getUVLightList()"></i>
                    </el-input>
                </div>
            </div>
            <div class="airPurifiers_right_main">
                <div class="main_top">
                    <div class="main_top_l">
                        <div class="div1"><span>{{$t('App.sideBar.text18')}}</span></div>
                        <div class="div2">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                            <div class="btn" @click="delLight(checkList,'batch')">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.lights.text1')}}</span>
                            </div>
                            <div class="btn" @click="setTotalLight(checkList,1)" v-loading="loading.setTotalLight">
                                <span>{{$t('App.uvLight.text7')}}</span>
                            </div>
                            <div class="btn" @click="setTotalLight(checkList,0)" v-loading="loading.setTotalLight">
                                <span>{{$t('App.uvLight.text8')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="main_top_r">
                        <div class="btn" @click="addUVLightFun()"><img :src="img_lights_3"><span>{{$t('App.lights.text5')}}</span></div>
                    </div>
                </div>
                <div class="main_cont">
                    <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                        <el-table
                            ref="uvLightDataList"
                            v-loading="loading.uvLightDataList"
                            height="100%"
                            :data="uvLightDataList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'index'"
                                align="left"
                                header-align="center"
                                :width="6*remRatio">
                                <template slot-scope="scope">
                                    <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-for="(item) in uvLightArr"
                                :key="'table_'+item.prop"
                                :prop="item.prop"
                                :label="item.label"
                                :align="item.align?item.align:'center'"
                                :header-align="item.hAlign?item.hAlign:'center'"
                                :width="item.width"
                                :show-overflow-tooltip="true"
                                :min-width="item.minWidth">
                                    <template slot-scope="scope">
                                        <span v-if="item.type != 1">{{scope.row[item.prop]}}{{item.unit?item.unit:''}}</span>
                                        <span v-if="item.prop == 'TVOC'">{{tvocArr[scope.row[item.prop]]}}</span>

                                        <div v-if="item.prop == 'netOnline'" class="online">
                                            <i v-if="scope.row.netOnline=='0'" class="iconfont icon-disconnect" style="color:rgba(163,175,187,1);"></i>
                                            <i v-if="scope.row.netOnline=='1'" class="iconfont icon-connectx" :style="{'color': version=='0'?'rgba(5, 207, 171, 1)':'#8266C7'}"></i>
                                        </div>
                                        <div v-if="item.prop == 'road1_online_status'" v-loading="scope.row.statusLoading">
                                            <p class="p p1">
                                                <span class="span1" :class="{'online':scope.row['road1_online_status'] == 1}">{{onlineStatusArr[scope.row['road1_online_status']]}}</span>
                                                <span class="span2" :class="{'fault':scope.row['road1_online_status'] == 1}">{{faultStatusArr[scope.row['road1_fault_status']]}}</span>
                                            </p>
                                            <p class="p p2">
                                                <span class="span1" v-if="scope.row['road2_total_time']">{{$t('App.uvLight.tableText4')}}{{scope.row['road2_total_time']}}h</span>
                                                <span class="span1" v-if="!scope.row['road2_total_time']">-</span>
                                            </p>
                                            <p class="p p3">
                                                <span class="span1">{{scope.row['road1_switch_status'] === 1?$t('App.uvLight.tableText2_1'):$t('App.uvLight.tableText2_0')}}</span>
                                                <span v-loading="scope.row.loading1" class="pl_switch" :class="{'checked':scope.row['road1_switch_status'] === 1}" @click="plSwitchFun(scope.row,'1')"></span>
                                            </p>
                                        </div>
                                        <div v-if="item.prop == 'road2_online_status'" v-loading="scope.row.statusLoading">
                                            <p class="p p1">
                                                <span class="span1" :class="{'online':scope.row['road2_online_status'] == 1}">{{onlineStatusArr[scope.row['road2_online_status']]}}</span>
                                                <span class="span2" :class="{'fault':scope.row['road2_online_status'] == 1}">{{faultStatusArr[scope.row['road2_fault_status']]}}</span>
                                            </p>
                                            <p class="p p2">
                                                <span class="span1" v-if="scope.row['road2_total_time']">{{$t('App.uvLight.tableText4')}}{{scope.row['road2_total_time']}}h</span>
                                                <span class="span1" v-if="!scope.row['road2_total_time']">-</span>
                                            </p>
                                            <p class="p p3">
                                                <span class="span1">{{scope.row['road2_switch_status'] === 1?$t('App.uvLight.tableText2_1'):$t('App.uvLight.tableText2_0')}}</span>
                                                <span v-loading="scope.row.loading1" class="pl_switch" :class="{'checked':scope.row['road2_switch_status'] === 1}" @click="plSwitchFun(scope.row,'1')"></span>
                                            </p>
                                        </div>
                                        <div v-if="item.prop == 'road3_online_status'" v-loading="scope.row.statusLoading">
                                            <p class="p p1">
                                                <span class="span1" :class="{'online':scope.row['road3_online_status'] == 1}">{{onlineStatusArr[scope.row['road3_online_status']]}}</span>
                                                <span class="span2" :class="{'fault':scope.row['road3_online_status'] == 1}">{{faultStatusArr[scope.row['road3_fault_status']]}}</span>
                                            </p>
                                            <p class="p p2">
                                                <span class="span1" v-if="scope.row['road3_total_time']">{{$t('App.uvLight.tableText4')}}{{scope.row['road3_total_time']}}h</span>
                                                <span class="span1" v-if="!scope.row['road3_total_time']">-</span>
                                            </p>
                                            <p class="p p3">
                                                <span class="span1">{{scope.row['road3_switch_status'] === 1?$t('App.uvLight.tableText2_1'):$t('App.uvLight.tableText2_0')}}</span>
                                                <span v-loading="scope.row.loading1" class="pl_switch" :class="{'checked':scope.row['road3_switch_status'] === 1}" @click="plSwitchFun(scope.row,'1')"></span>
                                            </p>
                                        </div>
                                        <div v-if="item.prop == 'road4_online_status'" v-loading="scope.row.statusLoading">
                                            <p class="p p1">
                                                <span class="span1" :class="{'online':scope.row['road4_online_status'] == 1}">{{onlineStatusArr[scope.row['road4_online_status']]}}</span>
                                                <span class="span2" :class="{'fault':scope.row['road4_online_status'] == 1}">{{faultStatusArr[scope.row['road4_fault_status']]}}</span>
                                            </p>
                                            <p class="p p2">
                                                <span class="span1" v-if="scope.row['road4_total_time']">{{$t('App.uvLight.tableText4')}}{{scope.row['road4_total_time']}}h</span>
                                                <span class="span1" v-if="!scope.row['road4_total_time']">-</span>
                                            </p>
                                            <p class="p p3">
                                                <span class="span1">{{scope.row['road4_switch_status'] === 1?$t('App.uvLight.tableText2_1'):$t('App.uvLight.tableText2_0')}}</span>
                                                <span v-loading="scope.row.loading1" class="pl_switch" :class="{'checked':scope.row['road4_switch_status'] === 1}" @click="plSwitchFun(scope.row,'1')"></span>
                                            </p>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                align="center"
                                :width="8*remRatio"
                                :label="$t('App.uvLight.tableLabel11')">
                                <template slot-scope="scope">
                                    <span class="btn" @click="editFun(scope.row)" :title="$t('App.lights.text7')">
                                        <i class="iconfont icon-bianji"></i>
                                    </span>
                                    <span class="btn" @click="delLight(scope.row,false)" :title="$t('App.lights.text1')">
                                        <i class="iconfont icon-delete"></i>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-checkbox-group>
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!--  -->
        <div class="purifier_wrap scrollbar_style" v-show="devTkShowbg">
            <div class="purifier_wrap_bg" @click="purifierTkClose()"></div>
            <div class="purifier_box" :class="{'purifier_tk_show':devTkShow}">
                <div class="purifier_title">
                    <span class="span1">{{purifierTkTitle}}</span>
                    <span class="span2" @click="purifierTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.uvLight.text3')}}</span>
                        <el-input v-model="uvLightForm.name" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.uvLight.text4')}}</span>
                        <el-input v-model="uvLightForm.sn" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.uvLight.text5')}}</span>
                        <el-dropdown @command="commandPort" trigger="click" @visible-change="commandHide('dropdown_lights_model')">
                            <span class="span1">{{uvLightFormPortName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_lights_model">
                                <el-dropdown-item v-for="item in portNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==uvLightForm.port}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.uvLight.text6')}}</span>
                        <el-input v-model="uvLightForm.address" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-dropdown @command="commandFloor" trigger="click" @visible-change="commandHide('dropdown_air_floor')">
                            <span class="span1">{{uvLightFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_air_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==uvLightForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text30')}}</span>
                        <el-dropdown @command="commandRoom" trigger="click" @visible-change="commandHide('dropdown_air_room')">
                            <span class="span1">{{uvLightFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_air_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'room'+item.id" :class="{'select':item.id==uvLightForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveUV()">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    export default {
        name:'airPurifiers',
        data () {
            return{
                buildId:'',
                buildNav:[],
                keywords:'',
                floorNav:[],
                roomNav:[],

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                uvLightArr:[],
                uvLightDataList:[],
                purifierDataIdList:[],
                onlineArr:['Off-line','On-line'],
                levelArr:['Low','Middle','High'],
                levelArrObj:[{id:1,name:'Low'},{id:2,name:'Middle'},{id:3,name:'High'}],
                levelArrObjNew:[{id:0,name:'Null'},{id:1,name:'Low'},{id:2,name:'Middle'},{id:3,name:'High'}],
                tvocArr:['level1','level2','level3'],
                level_:'',
                status_:'',

                currentPage:1,
                pageSize:20,
                total:1000,

                devTkShowbg:false,
                devTkShow:false,
                uvLightForm:{
                    name:'',
                    sn:'',
                    port:'0',
                    floorId:'',
                    roomId:'',
                    address:'',
                    // type:'0',
                },
                uvLightFormFloorName:'',
                uvLightFormRoomName:'',
                purifierTkTitle:'',
                portNav:[],

                historyShowbg:false,
                historyShow:false,
                networHistoryType:'1',
                chartType:'0',
                chartTypeStr:'line',
                chartTypeArr:[{label:'Line',value:'0',str:'line'},{label:'Bar',value:'1',str:'bar'}],
                timeType1:'0',
                timeType2:'0',
                timeTypeStr:'Daily',
                timeTypeArr:[{label:'Daily',value:'0'},{label:'Weekly',value:'4'},{label:'Monthly',value:'1'},{label:'Yearly',value:'2'}],

                reDataIndex:0,

                purifierSettingTkShowbg:false,
                purifierSettingTkShow:false,
                purifierSettingTkTitle:'Setting',
                // purifierSettingForm:{
                //     uTime:0,
                //     purModel:'0',
                // },
                purModelArr:[{id:'0',name:'Manual mode'},{id:'1',name:'Auto mode'}],

                gatewayUpdateTkShowbg:false,
                gatewayUpdateTkShow:false,
                uploadGatewayVal:0,
                gatewayUpdateType:'1',
                gatewayUpdateSoftware:'',
                gatewayUpdateVersion:'',
                gatewayUpdateStatus:'1',

                loading:{
                    uvLightDataList:false,
                    setTotalLight:false,
                },

                img_lights_3:'',
                updateRemRatioShakeProof:null,

                delDelIs_true:false,

                onlineStatusArr:[],
                faultStatusArr:[],
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
                role:'role',

                remRatio:'remRatio',
                updateRemRatio:'updateRemRatio',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',
            }),
            uvLightFormPortName(){
                let name = '';
                for(let d of this.portNav){
                    if(d.id == this.uvLightForm.port){
                        name = d.name
                    }
                }
                return name
            }
        },
        components:{
            // 'sideBar':sideBar
        },
        beforeDestroy(){
            if(this.websocket){
                this.websocket.close();
            }
        },
        mounted(){
            this.onlineStatusArr = [this.$t('App.uvLight.onlineStatusTetx1'),this.$t('App.uvLight.onlineStatusTetx2')];
            this.faultStatusArr = [this.$t('App.uvLight.faultStatusText1'),this.$t('App.uvLight.faultStatusText2')];

            this.img_lights_3 = require('../img/room/map/lights_3.png');

            if(this.version == '1'){
                this.img_lights_3 = require('../img/room/map/lights_3_v1.png');
            }

            this.alertsArr = [this.$t('App.room_light.text59'),this.$t('App.room_light.text60')];
            this.onlineArr = [this.$t('App.room.text65'),this.$t('App.room.text66')];
            this.levelArr = [this.$t('App.room.text68'),this.$t('App.room.text69'),this.$t('App.room.text70')];
            this.tvocArr = [this.$t('App.room.text68'),this.$t('App.room.text69'),this.$t('App.room.text70')];
            this.levelArrObj = [{id:'1',name:this.$t('App.room.text68')},{id:'2',name:this.$t('App.room.text69')},{id:'3',name:this.$t('App.room.text70')}];
            this.levelArrObjNew = [{id:'0',name:this.$t('App.room.text67_')},{id:'1',name:this.$t('App.room.text68')},{id:'2',name:this.$t('App.room.text69')},{id:'3',name:this.$t('App.room.text70')}];

            
            this.chartTypeArr = [{label:this.$t('App.room_light.text61'),value:'0',str:'line'},{label:this.$t('App.room_light.text62'),value:'1',str:'bar'}];

            this.timeTypeStr = this.$t('App.room_light.text63');
            this.timeTypeArr = [{label:this.$t('App.room_light.text63'),value:'0'},{label:this.$t('App.room_light.text64'),value:'4'},{label:this.$t('App.room_light.text65'),value:'1'},{label:this.$t('App.room_light.text66'),value:'2'}];

            this.purifierSettingTkTitle = this.$t('App.airPurifiers.text1');

            this.purModelArr = [{id:'0',name:this.$t('App.airPurifiers.text12')},{id:'1',name:this.$t('App.airPurifiers.text13')},{id:'2',name:this.$t('App.airPurifiers.text24')}];

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })

            this.portNav = [
                {id:2,name:'1号串口'},
                {id:1,name:'2号串口'},
                {id:0,name:'3号串口'}
            ]
            this.uvLightArr = [
                {prop:'name',label:this.$t('App.uvLight.tableLabel1'),width:8*this.remRatio},
                {prop:'address',label:this.$t('App.uvLight.tableLabel2'),minWidth:6.5*this.remRatio},
                {prop:'floor',label:this.$t('App.uvLight.tableLabel3'),minWidth:5*this.remRatio},
                {prop:'roomNumber',label:this.$t('App.uvLight.tableLabel4'),minWidth:5*this.remRatio},
                {prop:'netOnline',label:this.$t('App.uvLight.tableLabel5'),width:(this.version==1?6:10)*this.remRatio,type:1},

                {prop:'road1_online_status',label:this.$t('App.uvLight.tableLabel6'),width:(this.version==1?10:12)*this.remRatio,type:1,hAlign:'left'},
                {prop:'road2_online_status',label:this.$t('App.uvLight.tableLabel7'),width:(this.version==1?10:12)*this.remRatio,type:1,hAlign:'left'},
                {prop:'road3_online_status',label:this.$t('App.uvLight.tableLabel8'),width:(this.version==1?10:12)*this.remRatio,type:1,hAlign:'left'},
                {prop:'road4_online_status',label:this.$t('App.uvLight.tableLabel9'),width:(this.version==1?10:12)*this.remRatio,type:1,hAlign:'left'},

                {prop:'updateTime',label:this.$t('App.uvLight.tableLabel10'),width:11.5*this.remRatio},
            ];
            this.getBuildNav(()=>{
                if(this.buildNav.length > 0){
                    this.buildId = this.buildNav[0].id;
                }else{
                    this.buildId = '';
                }
                this.getUVLightList();
            });
            base.websocket_close(allUrl.websocket.ws,websocket=>{
                // console.log(websocket)
                this.websocket = websocket;
                this.websocket.send('{"type":"cmd"}');
                websocket.onmessage = event => {
                    console.log(JSON.parse(event.data));
                    let data = JSON.parse(event.data)
                    if(data.code == '0000'){
                        if(data.data.status == '1'){
                            this.clientid = data.data.clientid
                        }
                        if(data.data.status == '2'){
                            this.$notify({
                                title: data.msg,
                                message: this.$t('App.message.text21')+data.data.name,
                                type: 'success'
                            });
                            if(data.data.type == 'delete'){
                                this.getUVLightList();
                            }
                            if(data.data.type == 'trun_off'){
                                for(let d of this.uvLightDataList){
                                    if(d.id == data.data.id){
                                        d.statusLoading = false;
                                    }
                                }
                            }
                            if(data.data.type == 'ref_data'){
                                this.reDataIndex--;
                                if(this.reDataIndex<0){
                                    this.reDataIndex = 0;
                                }
                                this.getUVLightList();
                            }
                        }
                    }else{
                        this.$alert(data.msg, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        if(data.data.type == 'trun_off'){
                            for(let d of this.uvLightDataList){
                                if(d.id == data.data.id){
                                    d.statusLoading = false;
                                    d.status = this.status_;
                                    d.level = this.level_;
                                }
                            }
                        }
                            
                    }
                }
            },this)

        },
        methods:{

            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            get_mode_and_time(id,callback){
                base.ajax_post(
                    allUrl.roomLight.get_mode_and_time,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        uvLightId:id,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            purifierSettingTkClose(){
                let this_ = this;
                this.purifierSettingTkShow = false;
                setTimeout(function(){
                    this_.purifierSettingTkShowbg = false;
                },400)
            },

            getGatewayList(callback){
                if(this.buildId){
                    this.loading.gatewayDataList = true;
                    base.ajax_post(
                        allUrl.gateway.getlist,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:1,
                            count:10,
                            type:'0',
                            // keywords:this.keywords,
                        },
                        {},
                        data=>{
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*编辑设备*/
            editFun(item){
                this.purifierTkTitle = this.$t('App.uvLight.text2');
                this.devTkShowbg = true;
                for(let key in this.uvLightForm){
                    this.uvLightForm[key] = item[key];
                }
                this.uvLightId = item.id;
                this.getFloorNav(()=>{
                    for(let d of this.floorNav){
                        if(d.id == this.uvLightForm.floorId){
                            this.uvLightFormFloorName = d.name;
                        }
                    }
                })
                this.getRoomNav(()=>{
                    for(let d of this.roomNav){
                        console.log(d,this.uvLightForm.roomId)
                        if(d.id == this.uvLightForm.roomId){
                            this.uvLightFormRoomName = d.number;
                        }
                    }
                });
                this.$nextTick(function(){
                    this.devTkShow = true;
                })
            },
            /*添加设备*/
            addUVLightFun(){
                this.purifierTkTitle = this.$t('App.uvLight.text1');
                this.devTkShowbg = true;
                for(let key in this.uvLightForm){
                    this.uvLightForm[key] = '';
                }
                this.uvLightForm.port = '2';
                this.uvLightFormFloorName = '';
                this.uvLightFormRoomName = '';
                this.uvLightId = null;
                this.getFloorNav(()=>{
                    if(this.floorNav.length > 0){
                        this.uvLightForm.floorId = this.floorNav[0].id;
                        for(let d of this.floorNav){
                            if(d.id == this.uvLightForm.floorId){
                                this.uvLightFormFloorName = d.name;
                            }
                        }
                        this.getRoomNav(()=>{
                            if(this.roomNav.length > 0){
                                this.uvLightForm.roomId = this.roomNav[0].id;
                                for(let d of this.roomNav){
                                    if(d.id == this.uvLightForm.roomId){
                                        this.uvLightFormRoomName = d.number;
                                    }
                                }
                            }
                        });
                    }
                })
                this.$nextTick(function(){
                    this.devTkShow = true;
                })
            },
            purifierTkClose(){
                let this_ = this;
                this.devTkShow = false;
                setTimeout(function(){
                    this_.devTkShowbg = false;
                },400)
            },
            commandPort(data){
                this.uvLightForm.port = data.id;
            },
            commandFloor(data){
                this.uvLightForm.floorId = data.id;
                this.uvLightFormFloorName = data.name;
                this.getRoomNav(()=>{
                    this.uvLightForm.roomId = '';
                    this.uvLightFormRoomName = ''
                });
                this.uvLightForm.roomId = '';
            },
            commandRoom(data){
                this.uvLightForm.roomId = data.id;
                this.uvLightFormRoomName = data.number;
            },
            /*保存*/
            postSaveUV(){
                let this_ = this;
                base.ajax_post(
                    allUrl.uvLight.save,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:this.uvLightId,
                        buildId:this.buildId,
                        ...this.uvLightForm
                    },
                    {},
                    data=>{
                        this.devTkShow = false;
                        setTimeout(function(){
                            this_.devTkShowbg = false;
                        },400)
                    
                        this.getUVLightList();
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                    },
                    this
                )
                
            },
            /*删除设备*/
            delLight(obj,type){
                let uvLightId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text11'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(uvLightId == ''){
                                uvLightId = id;
                            }else{
                                uvLightId += ','+id;
                            }
                        }
                    }
                }else{
                    uvLightId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text16'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.uvLight.del,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                id:uvLightId,
                            },
                            {},
                            obj=>{
                                this.$message({
                                    showClose: true,
                                    message: obj.msg,
                                    type: 'success'
                                });
                                this.getUVLightList();
                            },
                            this,()=>{

                            }
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            setTotalLight(list,status){
                if(this.loading.setTotalLight){
                    return
                }
                let uvLightId = '',isTrue = true;
                if(list.length == 0){
                    isTrue = false;
                    this.$message({
                        message: this.$t('App.message.text11'),
                        type: 'warning'
                    });
                }else{
                    for(let id of list){
                        if(uvLightId == ''){
                            uvLightId = id;
                        }else{
                            uvLightId += ','+id;
                        }
                    }
                }
                if(isTrue){
                    this.loading.setTotalLight = true;
                    base.ajax_post(
                        allUrl.uvLight.setTotalLight,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            id:uvLightId,
                            status:status
                        },
                        {},
                        obj=>{
                            this.loading.setTotalLight = false;
                            let this_ = this;
                            let i = 0;
                            timeout(obj.data.operation[i])
                            function timeout(d){
                                if(d.code == '0000'){
                                    this_.$notify({
                                        title: d.msg,
                                        message: this_.$t('App.uvLight.tableLabel2')+' '+d.address,
                                        type: 'success',
                                        duration: 0
                                    });
                                }else{
                                    this_.$notify({
                                        title: d.msg,
                                        message: this_.$t('App.uvLight.tableLabel2')+' '+d.address,
                                        type: 'warning',
                                        duration: 0
                                    });
                                }
                                i++
                                if(i<obj.data.operation.length){
                                    setTimeout(()=>{
                                        timeout(obj.data.operation[i])
                                    },300)
                                }
                            }
                            this.getUVLightList();
                        },
                        this,()=>{

                        }
                    )
                }
            },
            /*设备列表*/
            getUVLightListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getUVLightList();
                }
            },
            getUVLightList(callback){
                if(this.buildId){
                    this.loading.uvLightDataList = true;
                    base.ajax_post(
                        allUrl.uvLight.getList,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:this.currentPage,
                            count:this.pageSize,
                            keywords:this.keywords,
                        },
                        {},
                        data=>{
                            this.uvLightDataList = data.data.list;
                            this.total = Number(data.data.total);
                            this.loading.uvLightDataList = false;

                            this.purifierDataIdList = [];
                            this.checkList = [];
                            this.isIndeterminate = false;
                            this.checkAll = false;
                            let i = 1 + (this.currentPage-1)*this.pageSize;
                            for(let d of this.uvLightDataList){
                                this.$set(d,'loading1',false);
                                this.$set(d,'loading2',false);
                                this.$set(d,'loading3',false);
                                this.$set(d,'loading4',false);

                                this.purifierDataIdList.push(d.id);
                                d.status = Number(d.status)
                                d.webIndex = i;
                                i++;
                            }
                            if(callback){
                                callback(data)
                            }
                            this.$nextTick(function(){
                                this.$refs.uvLightDataList.doLayout();
                            })
                        },
                        this,()=>{
                            this.loading.uvLightDataList = false;
                        }
                    )

                }
            },
            /*楼房下拉列表*/
            getBuildNav(callback){
                if(this.hotelId){
                    base.ajax_post(
                        allUrl.room.buildNav,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                        },
                        {},
                        data=>{
                            this.buildNav = data.data.list;
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*楼层下拉列表*/
            getFloorNav(callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        this.floorNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼间下拉列表*/
            getRoomNav(callback){
                base.ajax_post(
                    allUrl.room.roomNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        floorId:this.uvLightForm.floorId,
                    },
                    {},
                    data=>{
                        this.roomNav = data.data.list;
                        console.log(this.roomNav)
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            plSwitchFun(data,type){
                if(!data['loading'+type]){
                    if(data.online == 0){
                        this.$notify({
                            message: this.$t('App.message.text9'),
                            type: 'warning'
                        });
                    }else if(data.blueStatus==0){
                        this.$notify({
                            message: this.$t('App.message.text15'),
                            type: 'warning'
                        });
                    }else{
                        if(data['road'+type+'_switch_status'] == 1){
                            data['road'+type+'_switch_status'] = 0
                        }else{
                            data['road'+type+'_switch_status'] = 1
                        }
                        data['loading'+type] = true;
                        base.ajax_post(
                            allUrl.uvLight.setLight,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                id:data.id,
                                channel:type - 1,
                                status:data['road'+type+'_switch_status'],
                            },
                            {},
                            obj=>{
                                data['loading'+type] = false;
                                this.$message({
                                    showClose: true,
                                    message: obj.msg,
                                    type: 'success'
                                });
                            },
                            this,()=>{
                                if(data['road'+type+'_switch_status'] == 1){
                                    data['road'+type+'_switch_status'] = 0
                                }else{
                                    data['road'+type+'_switch_status'] = 1
                                }
                                data['loading'+type] = false;
                            }
                        )
                    }
                }
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = 1;
                this.getUVLightList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getUVLightList();
                // console.log(val)
            },

            handleCheckAllChange(val) {
                this.checkList = val ? this.purifierDataIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.purifierDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.purifierDataIdList.length;
            },
        },
        watch:{
            hotelId:function(){
                this.getBuildNav(()=>{
                    if(this.buildNav.length > 0){
                        this.buildId = this.buildNav[0].id;
                        this.getFloorNav(data=>{
                            this.tableFloorNav = data.data.list
                        })
                    }else{
                        this.buildId ='';
                    }
                    this.currentPage = 1;
                    this.getUVLightList();
                });
            },
            buildId:function () {
                this.currentPage = 1;
                this.getUVLightList();
            },
            updateRemRatio:function(){
                clearTimeout(this.updateRemRatioShakeProof)
                this.updateRemRatioShakeProof = setTimeout(()=>{
                    this.uvLightArr = [
                        {prop:'name',label:this.$t('App.uvLight.tableLabel1'),width:8*this.remRatio},
                        {prop:'address',label:this.$t('App.uvLight.tableLabel2'),minWidth:6.5*this.remRatio},
                        {prop:'floor',label:this.$t('App.uvLight.tableLabel3'),minWidth:5*this.remRatio},
                        {prop:'roomNumber',label:this.$t('App.uvLight.tableLabel4'),minWidth:5*this.remRatio},
                        {prop:'netOnline',label:this.$t('App.uvLight.tableLabel5'),width:(this.version==1?6:10)*this.remRatio,type:1},

                        {prop:'road1_online_status',label:this.$t('App.uvLight.tableLabel6'),width:(this.version==1?10:12)*this.remRatio,type:1,hAlign:'left'},
                        {prop:'road2_online_status',label:this.$t('App.uvLight.tableLabel7'),width:(this.version==1?10:12)*this.remRatio,type:1,hAlign:'left'},
                        {prop:'road3_online_status',label:this.$t('App.uvLight.tableLabel8'),width:(this.version==1?10:12)*this.remRatio,type:1,hAlign:'left'},
                        {prop:'road4_online_status',label:this.$t('App.uvLight.tableLabel9'),width:(this.version==1?10:12)*this.remRatio,type:1,hAlign:'left'},

                        {prop:'updateTime',label:this.$t('App.uvLight.tableLabel10'),width:11.5*this.remRatio},
                    ];
                    this.$nextTick(function(){
                        this.$refs.uvLightDataList.doLayout();
                    })
                },1000)
            }
        }
    }
</script>

<style type="text/css" lang="less">
    .airPurifiers_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .airPurifiers_right{
                .airPurifiers_right_top .right_top_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .airPurifiers_right_main .main_cont{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                    .el-table{
                        .pl_switch{
                            &.checked{
                                &::after{
                                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                                }
                            }
                        }
                        .pl_switch.checked::after{
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                        .p1{
                            .online{
                                background-color: rgba(130, 102, 199,0.1);
                                color: rgba(130, 102, 199,1);
                            }
                            .span2{
                                background-color: rgba(130, 102, 199,0.1);
                                color: rgba(130, 102, 199,1);
                            }
                        }
                    }
                }
            }
            .history_warp .history_box{
                .table_box .pagination_box .el-pager li{
                    &:hover{
                        color: #513C93;
                        background:rgba(130,102,199,0.1);
                    }
                    &.active{
                        color: #FFFFFF;
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
                .table_top_box .box1 .btn.select{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
            }
            .purifier_wrap .purifier_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
        }
        .airPurifiers_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .airPurifiers_right{
            position: relative;
            padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100%);
            .airPurifiers_right_top{
                display: flex;
                justify-content: space-between;
                .right_top_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 11.42rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 20rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
            }
            .airPurifiers_right_main{
                height: calc(100% - 6.5rem);
                margin-top: 1rem;
                position: relative;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 1.67rem 0;
                    .main_top_l{
                        .div1{
                            margin-top: 1.5rem;
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1.5rem;
                            color: #333333;
                        }
                        .div2{
                            margin-top: 1.33rem;
                            display: flex;
                            .btn{
                                margin-left: 1.29rem;
                                display: flex;align-items: center;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                cursor: pointer;
                                i{
                                    font-size:0.8rem;
                                    color: #C6CDD5;
                                }
                                span{
                                    margin-left: 0.5rem;
                                }
                            }
                        }
                    }
                    .main_top_r{
                        margin-top: 2.33rem;
                        display: flex;
                        .btn{
                            margin-left: 1rem;
                            height: 2.5rem;line-height: 2.5rem;
                            padding: 0 1.25rem;
                            background: #FFFFFF;
                            border: 1px solid #F0F0F0;
                            border-radius: 1.25rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            img{
                                margin-right: 0.5rem;
                                height: 1rem;
                            }
                        }
                    }
                }
                .main_cont{
                    height: calc(100% - 11rem);
                    margin-top: 0.75rem;
                    .el-checkbox-group{
                        height: 100%;
                    }
                    .el-table{
                        .el-checkbox{
                            margin-left: 1.1rem;
                        }

                        .p{
                            display: flex;
                            height: 1.5rem;line-height: 1.5rem;
                            padding-bottom: 0.5rem;
                            font-size: 1rem;
                        }
                        .p1{
                            .span1{
                                background-color: rgba(246,248,250,1);
                                color: #657085;
                                padding: 0rem 0.5rem;
                            }
                            .online{
                                background-color: rgba(5,207,171,0.1);
                                color: rgba(5,207,171,1);

                                // background-color: rgba(130, 102, 199,0.1);
                                // color: rgba(130, 102, 199,1);
                            }
                            .span2{
                                padding: 0rem 0.5rem;
                                margin-left: 0.5rem;
                                background-color: rgba(5,207,171,0.1);
                                color: rgba(5,207,171,1);
                            }
                            .fault{
                                background-color: rgba(255,12,77,0.1);
                                color: rgba(255,12,77,1);
                            }
                        }
                        .p2{
                            .span1{
                                background-color: rgba(246,248,250,1);
                                color: #657085;
                                padding: 0rem 0.5rem;
                            }
                        }
                        .p3{
                            .span1{
                                background-color: rgba(246,248,250,1);
                                color: #657085;
                                padding: 0rem 0.5rem;
                                margin-right: 0.5rem;
                            }
                        }
                        .btn{
                            padding: 0.5rem;
                            cursor: pointer;
                            &+.btn{
                                margin-left: 0.2rem;
                            }
                            i{
                                color: #A3AFBB;
                                font-size:0.8rem;
                            }
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                padding: 0;
                            }
                        }
                        td{
                            padding: 0.5rem 0;
                            // height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .cell{
                            padding: 0;
                            .el-loading-spinner{
                                margin-top: -0.75rem;
                                .circular{
                                    width: 1.5rem;height: 1.5rem;
                                }
                            }
                        }
                        .el-loading-spinner{
                            height: 100%;
                            margin-top: 0;top: 50%;
                        }
                        .pl_switch{
                            position: relative;
                            display: inline-block;
                            width: 2.33rem;
                            height: 1.3rem;
                            background: #E1EAF1;
                            border-radius: 1.08rem;
                            cursor: pointer;
                            &::after{
                                position: absolute;
                                left: 0.2rem;top: 0.15rem;
                                width: 0.93rem;height: 0.93rem;border-radius: 50%;
                                content: '';
                                background: #A3AFBB;
                                transition: all 0.5s;
                            }
                            &.checked{
                                background: #E1F1E7;
                                &::after{
                                    left: 1.15rem;
                                    background: #05CFAB;
                                }
                            }
                        }
                        .level{
                            position: relative;
                            .el-dropdown{
                                margin-left: 0.83rem;
                                cursor: pointer;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                            .disabled{
                                position: absolute;
                                display: inline-block;
                                width: 100%;
                                height: 100%;
                                top: 0;
                                left: 0;
                                cursor: no-drop;
                            }
                        }
                        .online{
                            width: 4.8rem;
                            height: 1.8rem;
                            line-height: 1.8rem;
                            background: rgba(246,248,250,1);
                            border-radius: 0.67rem;
                            margin: 0 auto;
                            span{
                                position: relative;
                                margin: 0 0.3rem;
                                color:rgba(235, 239, 242, 1);
                            }
                            .iconfont{
                                font-size: 1.2rem;
                            }
                        }
                    }
                    .pagination_box{
                        .el-pagination{
                            float: right;
                            margin-top: 0.5rem;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .purifier_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .purifier_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .purifier_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.purifier_tk_show{
                    right: 0rem; 
                }
                .purifier_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        position: relative;
                        .unit{
                            position: absolute;
                            top: 0;
                            right: 0;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #657085;
                        }
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input-number{
                            width: calc(100% - 15rem);
                            .el-input{
                                width: 100%;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>